import axios from "axios";

export async function fetchData(url) {
    try {

        const {data : {main : {temp, temp_max, temp_min}, name, weather}} = await axios.get(url);

        const weatherData = {
            temp : Math.round(temp - 275.15),
            tempMax : Math.round(temp_max - 275.15),
            tempMin : Math.round(temp_min - 275.15),
            name,
            desc : weather[0].main,
            icon : weather[0].icon,
        }
        
        console.log(weatherData)
        return weatherData;
    }catch(err) {
        console.log(err)
    }
}